// extracted by mini-css-extract-plugin
export var button = "binYyPDtUTUsgVBiTSi9";
export var instuiPopClear = "Rq6QNzyGg_pH9KiKOcix";
export var popDescription = "PpBo4vshOoc31TzkSfyM";
export var popTitle = "K_rfHXMqNaaP9EznkdlG";